module.exports = __webpack_public_path__ + "static/media/uk.e5564902.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/uk.svg
// module id = 1417
// module chunks = 1